<!--
    Styles
-->

<style>


    /* main */

    #deals .filters {
        position: relative;
        padding-top: 20px;
        padding-bottom: 20px;
        justify-content: space-between;
    }
    #deals .filters > *:not(.ui-loader) {
        margin-left: 10px;
    }


    /* done button */

    #deals .filters .btn.done:not(.inactive) {
        border-color: var(--cl-orange);
        background: var(--cl-orange-light);
        color: var(--cl-black);
    }
    #deals .filters .btn.done:not(.inactive) svg {
        fill: var(--cl-orange);
    }


    /* extended button */

    #deals .filters .btn.extended {
        padding: 0;
    }
    #deals .filters .btn.extended.active {
        border-bottom-left-radius: 0;
    }
    #deals .filters .btn.extended > a {
        height: 100%;
    }
    #deals .filters .btn.extended > a:first-child {
        padding: 0 12px;
        position: relative;
    }
    #deals .filters .btn.extended > a:last-child {
        border-left: 1px solid var(--cl-blue);
    }
    #deals .filters .btn.extended .dropdown {
        color: var(--cl-black);

        /* align with the parent's borders */
        z-index: 1;
        right: -1px;
        box-sizing: content-box;
        border: 1px solid var(--cl-gray);
        border-top-color: var(--cl-blue);
    }
    #deals .filters .btn.extended .dropdown .option {
        line-height: 40px;
    }
    #deals .filters .btn.extended .dropdown .option svg {
        margin-left: 0; /* override */
        fill: var(--cl-gray);
    }


    /* primary button */

    #deals .filters .btn.primary {
        width: 140px;
    }


</style>



<!--
    Template
-->

<template>
    <div class="filters u-row">


        <!-- loader -->

        <ui-loader v-show="loading || request" />


        <!-- done toggle -->

        <a class="btn slim done round" :class="{inactive: params.done !== false}" @click="done(false)">
            <icon-check />
            <span>募集のみ表示</span>
        </a>

        <a class="btn slim done round" :class="{inactive: !params.done}" @click="done(true)">
            <icon-check />
            <span>成約のみ表示</span>
        </a>


        <!-- ??? -->

        <!--
        <ui-dropdown v-slot="{active, toggle}">

            <a class="btn slim inactive" @click="toggle">
                <span class="cl-black">募集･成約時期順</span>
                <icon-dropdown class="cl-blue" />
            </a>

            <div v-show="active">
                ???
            </div>

        </ui-dropdown>
        -->


        <!-- ??? -->

        <!--
        <a class="btn slim secondary">
            <icon-settings />
            <span>リスト設定</span>
        </a>
        -->


        <div class="u-flex" />


        <!-- import -->

        <a class="btn secondary" @click="wizard">
            <icon-download />
            <span>インポート</span>
        </a>


        <!-- export -->

        <ui-dropdown v-slot="{active, toggle}">

            <div class="btn secondary extended" :class="{active}">
                <a class="u-row" @click="active ? toggle() : download('csv')">
                    <icon-upload />
                    <span>エクスポート</span>

                    <div class="dropdown" v-show="active">
                        <a class="w4 u-row option" @click="download('csv')">
                            <icon-csv />
                            CSV
                        </a>
                        <a class="w4 u-row option" @click="download('xlsx')">
                            <icon-xls />
                            XSLX
                        </a>
                    </div>
                </a>
                <a class="u-row" @click="toggle">
                    <icon-dropdown />
                </a>
            </div>

        </ui-dropdown>


        <!-- new property -->

        <a class="btn primary" @click="add">
            <icon-property />
            <span>物件を追加</span>
        </a>


    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapGetters, mapMutations, mapActions} from 'vuex'

    import API from '@/common/modules/api'
    import Mime from '@/common/helpers/mime'
    import Saver from '@/common/helpers/saver'
    import fields from '@/common/configs/fields'

    import uiDropdown from '@/components/shared/ui/dropdown.vue'
    import uiLoader from '@/components/shared/ui/loader.vue'
    import iconCheck from '@/assets/icons/check-fill.svg'
    import iconDownload from '@/assets/icons/download.svg'
    import iconUpload from '@/assets/icons/upload.svg'
    import iconDropdown from '@/assets/icons/dropdown.svg'
    import iconCsv from '@/assets/icons/file-csv.svg'
    import iconXls from '@/assets/icons/file-xls.svg'
    import iconProperty from '@/assets/icons/document.svg'


    export default {

        components: {
            uiDropdown,
            uiLoader,
            iconCheck,
            iconDownload,
            iconUpload,
            iconDropdown,
            iconCsv,
            iconXls,
            iconProperty
        },

        props: [
            'loading'
        ],

        data () {
            return {
                request: null
            }
        },

        computed: {

            ...mapGetters('search', ['params']),

            undone () {
                return this.params.done === false;
            },

            filename () {
                const now = new Date();
                const date = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日`;
                return `物件データ_${date}`;
            }

        },

        methods: {

            ...mapMutations('search', ['setParams']),

            ...mapActions('toasts', ['error']),

            set (query) {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        ...this.params,
                        ...query
                    }
                })
            },

            done (value) {
                this.set({done: this.params.done === value ? undefined : value});
            },

            wizard () {
                this.$popup.show('import', null, {clearable: false})
                    .then(e => this.$emit('refresh', e));
            },

            add () {
                this.$popup.show('property', {}, {clearable: false})
                    .then(reload => this.$emit('refresh', reload));
            },

            download (ext) {
                if (this.request) return;

                const req = r => this.request = r;

                const mapping = fields.map(true);
                const type = Mime.lookup(ext);

                req(API('export'))
                    .then(({data: {key}}) => req(API('convert', key, {mapping}, {type})))
                    .then(({data: {url}}) => Saver.saveAs(url, this.filename + '.' + ext))
                    .catch(() => this.error('エクスポートに失敗しました。時間を置いてもう一度お試しください。'))
                    .finally(() => this.request = false);
            }

        },

        destroyed () {
            this.request && API.abort(this.request);
        }

    }

</script>

